export const copyToClipboard = (text: string) => {
  /**
   * There are security limitations on this API in (Mobile) Safari,
   * one of which is it has to be executed on a site secured with https, so will not work on localhost, for instance:
   * The API is limited to secure contexts, which means that navigator.clipboard is not present for http:// websites.
   * The request to write to the clipboard must be triggered during a user gesture.
   * A call to clipboard.write or clipboard.writeText outside the scope of a user gesture
   * (such as "click" or "touch" event handlers) will result in the immediate rejection of the promise returned by the API call.
   * https://webkit.org/blog/10855/async-clipboard-api/
   */
  return navigator.clipboard.writeText(text);
};
